import React from "react"
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome"
import { Button, Card, CardContent, Stack, Typography } from "@mui/material"
import { useNavigate } from "react-router-dom"
import { LOW_CREDITS_THRESHOLD } from "@/shared/constants/plans"

type BoostCreditsCardProps = {
  creditsRemaining: number
  onNavigate: () => void
}

export { LOW_CREDITS_THRESHOLD as BOOST_CREDITS_THRESHOLD } from "@/shared/constants/plans"

const BoostCreditsCard = ({ creditsRemaining, onNavigate }: BoostCreditsCardProps) => {
  const navigate = useNavigate()
  const isLowCredits = creditsRemaining <= LOW_CREDITS_THRESHOLD

  const handleNavigate = () => {
    onNavigate()
    navigate("/profile")
  }

  return (
    <Card variant="outlined" sx={{ borderRadius: 2 }}>
      <CardContent sx={{ p: 1.5, "&:last-child": { pb: 1.5 } }}>
        <Stack spacing={1}>
          <AutoAwesomeIcon fontSize="small" color="primary" />
          <Typography variant="subtitle2" fontWeight={700}>
            {isLowCredits ? "Credits running low" : "Boost your credits"}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {isLowCredits
              ? `Only ${creditsRemaining} credit${creditsRemaining === 1 ? "" : "s"} left. Top up to keep generating.`
              : "Buy more credits anytime — they never expire."}
          </Typography>
          <Button variant="contained" size="small" fullWidth onClick={handleNavigate}>
            {isLowCredits ? "Top up now" : "Buy credits"}
          </Button>
        </Stack>
      </CardContent>
    </Card>
  )
}

export default BoostCreditsCard
